
const API_ROOT = 'https://app-node.talkfintech.com:3016';
// const API_ROOT = 'http://localhost:3016';

//  const root_data = "https://talkfintech.ondotmail.com/updatedPostData/postData.json";

const webPath = 'https://talkfintech.com'
// const webPath = 'https://enterprisetalk.com'   // this is for images testig at local

export { API_ROOT, webPath };